<template>
<div class="search-control">
  <input
    ref="search"
    autocomplete="off"
    :placeholder="placeholder"
    :value="textSearch"
    @input="input"
    @keyup.esc="clearSearch"
  />
  <a 
    href="#"
    class="search-cancel"
    @click.prevent="clearSearch"
  >
    <span 
      class="icon" 
      data-icon="cancel">
    </span>
  </a>
</div>



</template>

<script>
export default {
  props: {
    textSearch: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    delay: {
      type: Number,
      default: 400
    }
  },

  data: function () {
    return {
      timeout: null
    };
  },

  methods: {
    input: function (event) {
      this.$emit('update:textSearch', event.target.value);
      this.debounceSearch();
    },

    clearSearch: function() {
      this.$refs.search.focus();
      this.$emit('update:textSearch', '');
      this.debounceSearch();
    },

    debounceSearch: function () {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.$emit('search');
      }, this.delay);
    }
  }
};
</script>
